import { render, staticRenderFns } from "./gc-wo-bulk-update-stale-diff-banner.vue?vue&type=template&id=d085b6a0"
import script from "./gc-wo-bulk-update-stale-diff-banner.vue?vue&type=script&lang=js"
export * from "./gc-wo-bulk-update-stale-diff-banner.vue?vue&type=script&lang=js"
import style0 from "./gc-wo-bulk-update-stale-diff-banner.vue?vue&type=style&index=0&id=d085b6a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports